import Vue from 'vue';
import snackbarApp from './app.vue';

export const initSnackBar = () => {
  const app = document.getElementById('fc-snackbar');
  if (app) {
    new Vue({
      render: (createEl) => createEl(snackbarApp),
    }).$mount('#fc-snackbar');
  }
};
